import { legacyRoutePrefix } from '@/router';

// healTarget decides the route to redirect to so a slugless/legacy or
// wrong-slug URL lands on its tenant. Pure: the caller supplies the resolved
// slug (from the DISCOVER_TENANT chain, see ./tenant-discovery.js) and a
// predicate telling whether a route name is an authenticated (slugged) route.
// Returns the target route object, or undefined when no healing is needed.
export const healTarget = (route, slug, isAuthenticatedRouteName) => {
  if (!route?.name || !slug) {
    return undefined;
  }

  // Legacy routes are named `legacy-${name}` and carry no tenantSlug in the URL.
  if (typeof route.name === 'string' && route.name.startsWith(legacyRoutePrefix)) {
    return {
      name: route.name.replace(legacyRoutePrefix, ''),
      params: { ...route.params, tenantSlug: slug },
      query: route.query,
    };
  }

  // Slugged route whose slug doesn't match the resolved one — re-heal it.
  if (route.params.tenantSlug !== slug && isAuthenticatedRouteName(route.name)) {
    return {
      ...route,
      params: { ...route.params, tenantSlug: slug },
    };
  }

  return undefined;
};
